<template>
  <div>
    <template v-if="currentPart">
      <h3 class="title">{{ currentPart.part }}</h3>
      <div class="elevation-1" :style="{ overflow: 'auto' }">
        <table class="survey-summary-table">
          <thead class="grey lighten-3">
            <tr class="text-no-wrap">
              <th></th>
              <th>{{ $t('question') }}</th>
              <th class="text-xs-right">{{ $t('evaluation_result') }}</th>
              <th class="text-xs-right">{{ $t('total_score') }}</th>
            </tr>
          </thead>
          <tbody
            v-for="(question, questionIndex) in currentPart.question_list"
            :key="`${page}-${questionIndex}`"
            class="black--text"
          >
            <tr class="primary lighten-3 font-weight-bold">
              <td class="text-xs-right">Q{{ questionIndex + 1 }}</td>
              <td :colspan="question.type === 'text' ? 1 : 3">{{ question.question }}</td>
              <td v-if="question.type === 'text'" :colspan="2" class="text-xs-right">
                <v-btn
                  small
                  color="primary"
                  class="ma-0"
                  @click="
                    viewChoice({
                      question: question.question,
                      answers: question.choices[0].answers
                    })
                  "
                  >{{ $t('view') }}</v-btn
                >
              </td>
            </tr>
            <template v-if="question.type !== 'text'">
              <tr
                v-for="(choice, choiceIndex) in question.choices"
                :key="`${page}-${questionIndex}-${choiceIndex}`"
              >
                <td></td>
                <td>
                  <v-container grid-list-lg class="pa-0" :style="{ width: '100% !important' }">
                    <v-layout wrap align-center>
                      <v-flex shrink>
                        {{ choice.text }}
                      </v-flex>
                      <v-flex shrink>
                        <v-btn
                          v-if="'note' in choice"
                          small
                          color="primary"
                          class="ma-0"
                          @click="
                            viewChoice({
                              question: question.question,
                              answers: choice.answers
                            })
                          "
                          >{{ $t('view') }}</v-btn
                        >
                      </v-flex>
                    </v-layout>
                  </v-container>
                </td>
                <td class="text-xs-right">{{ choice.score | numberFormat }}</td>
                <td class="text-xs-right">{{ choice.percent }}%</td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
    </template>
    <div class="mt-2">
      <v-pagination v-model="page" :length="parts().length" />
    </div>
    <SurveySummaryChoiceAnswerListDialog v-model="isChoiceAnswerListDialogVisible" />
  </div>
</template>

<script>
import SurveySummaryChoiceAnswerListDialog from './SurveySummaryChoiceAnswerListDialog.vue'

export default {
  components: { SurveySummaryChoiceAnswerListDialog },
  inject: ['parts', 'setViewedChoice'],
  data() {
    return {
      page: 1,
      isChoiceAnswerListDialogVisible: false
    }
  },
  computed: {
    currentPart() {
      return this.parts()[this.page - 1]
    }
  },
  methods: {
    viewChoice(data) {
      this.setViewedChoice(data)
      this.isChoiceAnswerListDialogVisible = true
    }
  }
}
</script>

<style lang="scss" scoped>
.survey-summary-table {
  width: 100%;

  th,
  td {
    padding: 8px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/view/dashboard/survey/SurveySummary/SurveySummaryTable.vue